import { ClientStatus } from "../type/client-status.enum";

export function getClientStatusColor(status: ClientStatus) {
  switch (status) {
    case ClientStatus.Active:
      return "success";
    case ClientStatus.Rescinded:
      return "error";
    case ClientStatus.Pending:
      return "info";
    // Fixed material purple (same in light & dark) to avoid any confusion
    // with the Betsson orange/accent colour.
    case ClientStatus.Suspended:
      return "purple";
    default:
      return "";
  }
}
